import { useRouter } from 'next/router';
import { useAuth } from 'src/contexts/AuthContext';
import { useEffect } from 'react';
import { firebaseAuth } from 'src/config/firebaseClient';
import { useAuthModal } from './useAuthModal';
import {
  applyActionCode,
  verifyPasswordResetCode,
  confirmPasswordReset,
} from 'firebase/auth';

export const useActionHandler = () => {
  const router = useRouter();
  const { user, isLoading } = useAuth();
  const { openAuthModal } = useAuthModal();
  const url = router.asPath;
  const mode = getParameterByName({ name: 'mode', url });
  const actionCode = getParameterByName({ name: 'oobCode', url });

  // eslint-disable-next-line @blumintinc/blumint/extract-global-constants
  const resetPassword = async (password: string) => {
    if (actionCode) {
      await verifyPasswordResetCode(firebaseAuth, actionCode);
      await confirmPasswordReset(firebaseAuth, actionCode, password);
    }
  };

  useEffect(() => {
    if (isLoading) {
      return;
    }
    if (mode === 'verifyEmail') {
      if (!user) {
        openAuthModal('enter email');
      }
      if (user && user.emailVerified) {
        openAuthModal('verifying email success');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, isLoading]);

  useEffect(() => {
    // eslint-disable-next-line @blumintinc/blumint/extract-global-constants
    const handler = async () => {
      if (mode === 'verifyEmail' && !!actionCode) {
        await applyActionCode(firebaseAuth, actionCode);
      }
      if (mode === 'resetPassword') {
        openAuthModal('reset password');
      }
    };
    handler();
  }, []);
  return { resetPassword };
};

export type GetParameterByNameProps = {
  name: string;
  url: string;
};

export function getParameterByName({ name, url }: GetParameterByNameProps) {
  const match = RegExp(`[?&]${name}=([^&]*)`).exec(url);
  return !!match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : undefined;
}
